import { render } from "./LineItem.vue?vue&type=template&id=48f84afa&scoped=true"
import script from "./LineItem.vue?vue&type=script&lang=js"
export * from "./LineItem.vue?vue&type=script&lang=js"

import "./LineItem.vue?vue&type=style&index=0&id=48f84afa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f84afa"]])

export default __exports__